<script>

    import { toast } from 'bulma-toast'
    import { modalStore, shopifysStore } from '../stores'

    import ShopifyService from '../$services/shopify.service'

    import Table from '../$components/table.svelte'
    import Button from '../$components/button.svelte'

    let loading = false
    let query = {
        admin: true,
    }

    getShopifyApps()

    async function getShopifyApps() {

        loading = true
        const resp = await ShopifyService.getShopifyApps(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        shopifysStore.set(resp.data)
    }

</script>

<Table items={ $shopifysStore.length } { loading } skeletonCols={5}>
    <div slot="header" class="header-filters">
        <div class="header-top">
            <Button on:click={() => modalStore.set('shopify_create_modal')} text="Agregar" icon="plus" />
        </div>
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-clipboard-check"></i></span>
                    <span>Estatus</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-user"></i></span>
                    <span>Usuario</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-globe"></i></span>
                    <span>Dominio</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                    <span>Acciones</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each $shopifysStore as shopify, index}
            <tr>
                <td>{ index + 1 }</td>
                <td>{ shopify.status }</td>
                <td>{ shopify.user && shopify.user.name }</td>
                <td>{ shopify.domain }</td>
                <td>
                    <Button on:click={() => modalStore.open('shopify', 'update_modal', shopify)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
